import * as actionTypes from './actionTypes';
import { createActionObject, getAjaxFunc, setToken, setUserId } from '../../helpers/common';
import { arrayOfStations as arrayOfStationsSchema, normalize } from '../../helpers/schema';
import * as api from '../api';

import { roles } from '../../users-mgmt/constants';
import * as strings from '../../helpers/strings';
import * as mqttMgr from '../../helpers/MqttMgr';

//@global Variables
var gl_mqttConfig = ""
var gl_userEmail = ""

export const reConnectMQTT = (userMQTTData) => {
  mqttMgr.connect(userMQTTData.mqttConfig, userMQTTData.user.email);
}


export const setUserIdCheckingIntervalId = intervalId => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_USER_ID_CHECKING_INTERVAL_ID,
    { intervalId }
  )
)

const loadSystemMenu = (role, dispatch, callback) => {
  var menuLoadFun;
  if (role === roles[0].value) {
    menuLoadFun = api.loadAdminUiAccess
  } else if (role === roles[1].value) {
    menuLoadFun = api.loadUserUiAccess
  } else {
    menuLoadFun = api.loadSubUserUiAccess
  }

  menuLoadFun()
    .then(paths => {
      dispatch(
        createActionObject(
          actionTypes.LOAD_USER_UI_ACCESS,
          {
            paths
          }
        )
      );
      api.loadGraphColors()
        .then(colors => {
          dispatch(
            createActionObject(
              actionTypes.LOAD_GRAPH_COLORS_SUCCESS,
              { colors }
            )
          );
          callback();
        });
    })
}

export const login = (email, password, callback) => dispatch => {
  dispatch(
    createActionObject(
      actionTypes.LOGIN_REQUEST,
      { message: "" }
    )
  );

  api.login({ email, password }, (status, data, responseText) => {
    switch (status) {
      case 200:
        setUserId(email);
        setToken(data.token);

        api.loadUserData(email)
          .then(({ status, data }) => {
            switch (status) {
              default:
                dispatch(
                  createActionObject(
                    actionTypes.LOGIN_SUCCESS
                  )
                );
                const { user, mqttConfig } = data;
                const { stationList } = user;
                // mqttMgr.connect(mqttConfig, user.email);
                dispatch(
                  createActionObject(
                    actionTypes.LOAD_USER_DATA_SUCCESS,
                    {
                      data: data,
                      user: user,
                      stations: normalize(stationList, arrayOfStationsSchema),
                      defaultStationId: stationList.length ? stationList[0].id : ""
                    }
                  )
                );

                loadSystemMenu(user.role, dispatch, callback);
            }
          });
        break;
      case 400:
        // Check if it's an invalid credential error
        if (responseText && (
          responseText.indexOf("InvalidCredentialException") > -1 ||
          responseText.indexOf("BadCredentialsException") > -1 ||
          responseText.toLowerCase().indexOf("invalid credential") > -1 ||
          responseText.toLowerCase().indexOf("bad credential") > -1
        )) {
          dispatch(
            createActionObject(
              actionTypes.SHOW_INCORRECT_CREDENTIAL_MSG,
              {
                message: strings.msgIncorrectCredential
              }
            )
          );
        } else {
          // Try to parse JSON response for error message
          let errorMessage = strings.msgLoginError;
          try {
            if (responseText) {
              const parsed = JSON.parse(responseText);
              if (parsed && parsed.message) {
                errorMessage = parsed.message;
              }
            }
          } catch (e) {
            // If JSON parsing fails, check if responseText contains error info
            if (responseText && responseText.trim().length > 0) {
              errorMessage = responseText;
            }
          }
          dispatch(
            createActionObject(
              actionTypes.LOGIN_FAILURE,
              {
                message: errorMessage
              }
            )
          );
        }
        break;
      case 401:
        dispatch(
          createActionObject(
            actionTypes.LOGIN_FAILURE,
            {
              message: strings.msgIncorrectCredential
            }
          )
        );
        break;
      default:
        if (responseText && (
          responseText.indexOf("BadCredentialsException") > -1 ||
          responseText.indexOf("InvalidCredentialException") > -1 ||
          responseText.toLowerCase().indexOf("invalid credential") > -1 ||
          responseText.toLowerCase().indexOf("bad credential") > -1
        )) {
          dispatch(
            createActionObject(
              actionTypes.SHOW_INCORRECT_CREDENTIAL_MSG,
              {
                message: strings.msgIncorrectCredential
              }
            )
          );
        } else {
          dispatch(
            createActionObject(
              actionTypes.LOGIN_FAILURE,
              {
                message: strings.msgLoginError
              }
            )
          );
        }
    }
  })
}

export const loadUserData = (email, callback) => dispatch => getAjaxFunc(
  actionTypes.LOAD_USER_DATA_REQUEST,
  "",
  actionTypes.LOAD_USER_DATA_FAILURE,
  "",
  dispatch
)(
  () => {
    return api.loadUserData(email)
      .then(({ status, data }) => {
        switch (status) {
          default:
            const { user, mqttConfig } = data;
            const { stationList } = user;
            // mqttMgr.connect(mqttConfig, user.email);
            gl_mqttConfig = mqttConfig;
            gl_userEmail = user.email
            dispatch(
              createActionObject(
                actionTypes.LOAD_USER_DATA_SUCCESS,
                {
                  data: data,
                  user: user,
                  stations: normalize(stationList, arrayOfStationsSchema),
                  defaultStationId: stationList.length ? stationList[0].id : ""
                }
              )
            );
            loadSystemMenu(user.role, dispatch, callback);
            return true;
        }
      }).catch(error => {
        setUserId("");
        setToken("");
        mqttMgr.disconnect();
        window.location.href = "/login";
      });
  }
)();

export const refreshToken = () => dispatch => {
  dispatch(
    createActionObject(
      actionTypes.LOGIN_REQUEST,
      { message: "" }
    )
  );

  api.refreshToken((status, data, responseText) => {

    switch (status) {
      case 200:
        setToken(data.token);
        dispatch(
          createActionObject(
            actionTypes.REFRESH_TOKEN_SUCCESS,
            {
              message: 'success'
            }
          )
        );
        break;
      case 500:
        api.logout();
        setUserId("");
        setToken("");
        dispatch(
          createActionObject(
            actionTypes.LOGOUT_REQUEST
          )
        );
        mqttMgr.disconnect();
        break;
      default:
        break;
    }

  })
}

export const logout = () => dispatch => {
  api.logout();
  setUserId("");
  setToken("");
  dispatch(
    createActionObject(
      actionTypes.LOGOUT_REQUEST
    )
  );
  mqttMgr.disconnect();
}

export const requestOTP = email => dispatch => getAjaxFunc(
  actionTypes.SEND_OPT_REQUEST,
  "",
  actionTypes.SEND_OPT_FAILURE,
  strings.msgUnknownErrorOccured,
  dispatch
)(
  () => api.requestOTPMail(email)
    .then(({ status }) => {
      switch (status) {
        case 200:
          dispatch(
            createActionObject(
              actionTypes.SEND_OPT_SUCCESS,
              {
                message: strings.msgResetPassworLinkSent,
              }
            )
          );
          return true;
        case 401:
          dispatch(
            createActionObject(
              actionTypes.SEND_OPT_FAILURE,
              {
                message: strings.msgInvalidEmail
              }
            )
          );
          return false;
        default:
          dispatch(
            createActionObject(
              actionTypes.SEND_OPT_FAILURE,
              {
                message: strings.msgUnknownErrorOccured
              }
            )
          );
          return false;
      }
    })
)()

export const resetPassword = (email, otp, password) => dispatch => getAjaxFunc(
  actionTypes.RESET_PASSWORD_REQUEST,
  "",
  actionTypes.RESET_PASSWORD_FAILURE,
  strings.msgUnknownErrorOccured,
  dispatch
)(
  () => api.resetPassword(email, otp, password)
    .then(({ status, message }) => {
      switch (status) {
        case 200:
          dispatch(
            createActionObject(
              actionTypes.RESET_PASSWORD_SUCCESS,
              {
                message: strings.msgPasswordIsReset,
              }
            )
          );
          return true;
        case 401:
          dispatch(
            createActionObject(
              actionTypes.RESET_PASSWORD_FAILURE,
              {
                message: message
              }
            )
          );
          return false;
        default:
          dispatch(
            createActionObject(
              actionTypes.RESET_PASSWORD_FAILURE,
              {
                message: strings.msgUnknownErrorOccured
              }
            )
          );
          return false;
      }
    })
)()